import { getHeaders } from '../../helpers/request/getHeaders';
import { removeItem } from '../../helpers/storage';
import { QueryConfig } from 'redux-query';
import { clearFeatureFlags } from '../../helpers/featureFlags/featureFlags';

interface IRequestData {
  type: string;
  body?: any;
  queryKey?: string;
}

export const logoutRequest = (data: IRequestData): QueryConfig => {
  const type = data.type;
  const requestData: QueryConfig = {
    // url: `${Env.API_URL}/logout`,
    url: 'https://httpstat.us/200?sleep=500',
    options: {
      method: 'POST',
      headers: getHeaders(),
    },
    queryKey: 'logout',
    body: data.body,
  };
  return {
    ...requestData,
    transform: (response: any) => ({
      // [`${type}`]: response,
      [`${type}`]: {
        status: 'OK',
        userId: 23,
        fullName: 'John Smith',
      },
    }),
    update: {
      [`${type}`]: (prev: any, next: any) => {
        removeItem('user');
        clearFeatureFlags();
        return next;
      },
    },
  };
};
